export default {
  className: 'returnExchangeRecords',
  readonly: true,
  fields: [
    'type',
    'user',
    'order',
    'detailedReason',
    {
      name: 'pictureCombination',
      note: '图片说明'
    },
    {
      name: 'status',
      width: 150
    }
  ],
  search: [
    'order',
    'status'
  ],
  action: {
    delete: false,
    create: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看退还货记录',
      component: 'viewPage'
    }
  }
}
